import { clearingApi } from "../../config/apiConfig";

const BASE = "api/v1/thg/prices";

/**
 * CLR-296 THG prices per year (incoming from the THG buyer, outgoing to station owners).
 *
 * Neither function throws. A refusal (400) carries the backend's `error` text, which is the message to show.
 */

/** @typedef {import("../../types/thgPrices").ThgPricesFailure} ThgPricesFailure */

/** @returns {ThgPricesFailure} */
const toFailure = (error, context, fallback) => {
  console.error(`Failed to ${context}:`, error);
  return {
    success: false,
    message: error?.response?.data?.error ?? fallback,
    status: error?.response?.status ?? null,
  };
};

export const getThgPrices = async () => {
  try {
    const response = await clearingApi.get(BASE);
    return { success: true, data: response?.data };
  } catch (error) {
    return toFailure(error, "load the THG prices", "Could not load the THG prices.");
  }
};

export const updateThgPrices = async (year, { incomingEurPerMwh, outgoingEurPerMwh }) => {
  try {
    const response = await clearingApi.put(`${BASE}/${year}`, { incomingEurPerMwh, outgoingEurPerMwh });
    return { success: true, data: response?.data };
  } catch (error) {
    return toFailure(
      error,
      `update the THG prices for ${year}`,
      `Could not save the THG prices for ${year}.`,
    );
  }
};
